module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-margin-bottom-30"
  }, [_vm._v("\n        Losses for Pension\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "future_loss_of_pension",
      "label": "Would you like to make a claim for loss of pension?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossOfPension),
      expression: "futureLossOfPension"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_loss_of_pension",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossOfPension = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [(_vm.futureLossOfPension) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Simple Method or Longden Method?\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_method",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pensionMethod),
      expression: "pensionMethod"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "pension_method",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pensionMethod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "simple"
    }
  }, [_vm._v("Simple")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "longden",
      "disabled": ""
    }
  }, [_vm._v("Longden (coming soon)")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.futureLossOfPension && _vm.pensionMethod) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Is there a lump sum payment?\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "lump_sum_loss",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lumpSumLoss),
      expression: "lumpSumLoss"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "lump_sum_loss",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lumpSumLoss = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")])])])], 1) : _vm._e()]), _vm._v(" "), (_vm.futureLossOfPension && _vm.lumpSumLoss !== null) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                'But For' Retirement Date"), (_vm.lumpSumLoss) ? _c('span', [_vm._v("/Date Lump Sum Would Have Been Taken")]) : _vm._e()]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_retirement_date",
      "table-control": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:but_for_retirement_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "but_for_retirement_date",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "update": _vm.updatePension
    },
    model: {
      value: (_vm.butForRetirementDate),
      callback: function($$v) {
        _vm.butForRetirementDate = $$v
      },
      expression: "butForRetirementDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                'But For' Retirement Age"), (_vm.lumpSumLoss) ? _c('span', [_vm._v("/Age Lump Sum Would Have Been Taken")]) : _vm._e()]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_retirement_date",
      "table-control": true,
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.butForRetirementAge),
      expression: "butForRetirementAge",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_retirement_age.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_retirement_age",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "but_for_retirement_age",
      "type": "number"
    },
    domProps: {
      "value": (_vm.butForRetirementAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.butForRetirementAge = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.butForRetirementAge < 50
    }
  }, [_vm._v("\n                Age of anticipated retirement is earlier than 50, contact the advice of an actuary.\n            ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.pensionMethod && _vm.lumpSumLoss) ? _c('div', [_c('h2', {
    staticClass: "u-margin-top-30"
  }, [_vm._v("\n            Lump Sum Loss\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    'But For' Pension Lump Sum\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_pension_lump_sum",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.butForPensionLumpSum),
      expression: "butForPensionLumpSum",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_pension_lump_sum.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_pension_lump_sum",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "but_for_pension_lump_sum",
      "type": "number"
    },
    domProps: {
      "value": (_vm.butForPensionLumpSum)
    },
    on: {
      "focus": function($event) {
        _vm.butForPensionLumpSum = _vm.butForPensionLumpSum || ''
      },
      "blur": [function($event) {
        _vm.butForPensionLumpSum = _vm.butForPensionLumpSum || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.butForPensionLumpSum = _vm._n($event.target.value)
      }, _vm.updatePension]
    }
  })]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.lumpSumValid
    }
  }, [_vm._v("\n                    'But For' Pension Lump Sum must be greater than the Lump Sum Payment After the Accident\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Lump Sum Payment After the Accident\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_lump_sum",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pensionLumpSum),
      expression: "pensionLumpSum",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pension_lump_sum.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "pension_lump_sum",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "pension_lump_sum",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pensionLumpSum)
    },
    on: {
      "focus": function($event) {
        _vm.pensionLumpSum = _vm.pensionLumpSum || ''
      },
      "blur": [function($event) {
        _vm.pensionLumpSum = _vm.pensionLumpSum || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pensionLumpSum = _vm._n($event.target.value)
      }, _vm.updatePension]
    }
  })]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.lumpSumValid
    }
  }, [_vm._v("\n                    Lump Sum Payment After the Accident must be less than the 'But For' Pension Lump Sum\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Date Lump Sum Payment Received\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_lump_sum_received",
      "table-control": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_lump_sum_received.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_lump_sum_received",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "update": _vm.updatePension
    },
    model: {
      value: (_vm.dateLumpSumPaymentReceived),
      callback: function($$v) {
        _vm.dateLumpSumPaymentReceived = $$v
      },
      expression: "dateLumpSumPaymentReceived"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.futureLossOfPension && _vm.lumpSumLossPresentValue) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [(_vm.lumpSumLossPresentValue) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Period of Accelerated Receipt\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "period_of_accelerated_receipt",
      "table-control": true,
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.periodOfAcceleratedReceipt),
      expression: "periodOfAcceleratedReceipt",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_pension_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_pension_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": "",
      "min": "0",
      "id": "period_of_accelerated_receipt",
      "type": "number"
    },
    domProps: {
      "value": (_vm.periodOfAcceleratedReceipt)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.periodOfAcceleratedReceipt = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Table 35 Discount Factor\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "table_27_multiplier",
      "table-control": true,
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "modal-name": 'multiplier_' + _vm.uniqueId,
      "endpoint": 'lumpSumMultiplier',
      "payload": _vm.lumpSumMultiplierModalPayload
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.discountFactor),
      expression: "discountFactor",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:table_27_multiplier.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "table_27_multiplier",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "table_27_multiplier",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.discountFactor)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.discountFactor = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Lump Sum Loss\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "lump_sum_loss_value",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.lumpSumLossPresentValue),
      expression: "lumpSumLossPresentValue",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:lump_sum_loss_value.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "lump_sum_loss_value",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "lump_sum_loss_value",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.lumpSumLossPresentValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.lumpSumLossPresentValue = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.futureLossOfPension && _vm.lumpSumLoss !== null) ? _c('div', [_c('h2', {
    staticClass: "u-margin-top-30"
  }, [_vm._v("\n            Pension Losses\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    'But For' Pension Annual Income\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_retirement_date",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.butForPensionAnnual),
      expression: "butForPensionAnnual",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_pension_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_pension_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "but_for_pension_annual",
      "type": "number"
    },
    domProps: {
      "value": (_vm.butForPensionAnnual)
    },
    on: {
      "focus": function($event) {
        _vm.butForPensionAnnual = _vm.butForPensionAnnual || ''
      },
      "blur": [function($event) {
        _vm.butForPensionAnnual = _vm.butForPensionAnnual || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.butForPensionAnnual = _vm._n($event.target.value)
      }, _vm.updatePension]
    }
  })]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.pensionAnnualIncomeValid
    }
  }, [_vm._v("\n                    'But For' Pension Annual Income must be greater than Actual Pension Annual Income\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Actual Pension Annual Income\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_annual",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pensionAnnual),
      expression: "pensionAnnual",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pension_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "pension_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "pension_annual",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pensionAnnual)
    },
    on: {
      "focus": function($event) {
        _vm.pensionAnnual = _vm.pensionAnnual || ''
      },
      "blur": [function($event) {
        _vm.pensionAnnual = _vm.pensionAnnual || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pensionAnnual = _vm._n($event.target.value)
      }, _vm.updatePension]
    }
  })]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.pensionAnnualIncomeValid
    }
  }, [_vm._v("\n                    Actual Pension Annual Income must be less than 'But For' Pension Annual Income\n                ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.futureLossOfPension && _vm.totalLoss) ? _c('div', [(_vm.lumpSumLoss) ? _c('h2', {
    staticClass: "u-margin-top-30"
  }, [_vm._v("\n            Total Losses\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Pension Multiplier\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "label": "Pension Multiplier",
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-show": !_vm.illHealthDisabilityPension,
      "modal-name": 'multiplier_' + _vm.uniqueId,
      "endpoint": 'pensionLossMultiplier',
      "payload": _vm.pensionLossMultiplierModalPayload
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pensionLossMultiplier),
      expression: "pensionLossMultiplier",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pension_loss_multiplier.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "pension_loss_multiplier",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "pension_loss_multiplier",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pensionLossMultiplier)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pensionLossMultiplier = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Annual Pension Loss\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pensionLossAnnual),
      expression: "pensionLossAnnual",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pension_loss_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "pension_loss_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "pension_loss_annual",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pensionLossAnnual)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pensionLossAnnual = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Total Annual Loss\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_annual",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.totalLossAnnual),
      expression: "totalLossAnnual",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:total_loss_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "total_loss_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "total_loss_annual",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.totalLossAnnual)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.totalLossAnnual = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), (_vm.futureLossOfPension && _vm.lumpSumLoss !== null && _vm.totalLoss) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Total Loss\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_annual",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.totalLoss),
      expression: "totalLoss",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:total_loss.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "total_loss",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "total_loss",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.totalLoss)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.totalLoss = _vm._n($event.target.value)
      }, _vm.updatePension],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'multiplier_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e636ef96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/other-future-losses/FuturePension.vue
// module id = 1826
// module chunks = 0